export const OS = {
  MAC: 'Mac',
  WINDOWS: 'Win',
  Linux: 'Linux',
};

export const getOS = () => {
  const userAgent = navigator?.userAgent;

  if (userAgent?.indexOf(OS.MAC) !== -1) {
    return OS.MAC;
  }

  if (userAgent?.indexOf(OS.WINDOWS) !== -1) {
    return OS.WINDOWS;
  }

  if (userAgent?.indexOf(OS.Linux) !== -1) {
    return OS.Linux;
  }

  return null;
};
